<template>
  <div class="pa-site-info pa-form-shell">
    <form-step
      ref="formStep"
      :site="site"
      :active-audit="activeAudit"
      :schema="schema"
      :sections="sections"
      :readonly="readonly"
      submit-mode="draft"
      expand-all
      @readiness-change="readinessTick += 1"
      @auditUpdated="$emit('audit-updated', $event)"
    />

    <p v-if="!readonly" class="pa-hint">Your answers are saved when you continue to the publishing step.</p>
    <p v-if="error" class="pa-err">{{ error }}</p>

    <div class="pa-formnav">
      <button type="button" class="pa-btn pa-btn--orange-out pa-btn--pill" :disabled="saving" @click="$emit('back')">
        <i class="material-icons" aria-hidden="true">arrow_back</i>Back
      </button>
      <button
        v-if="readonly"
        type="button"
        class="pa-btn pa-btn--orange pa-btn--pill"
        @click="$emit('continue')"
      >
        Continue<i class="material-icons" aria-hidden="true">arrow_forward</i>
      </button>
      <button
        v-else
        type="button"
        class="pa-btn pa-btn--orange pa-btn--pill"
        :disabled="!canContinue || saving"
        @click="save"
      >
        <span v-if="saving" class="pa-spin pa-spin--light"></span>
        Save &amp; continue to publishing<i class="material-icons" aria-hidden="true">arrow_forward</i>
      </button>
    </div>
  </div>
</template>

<script>
import FormStep from '@/components/SitesSingleView/WhiteGlove/SiteContentAuditWidget/FormStep.vue'
import { makePopAuthorityFormSchema, POP_AUTHORITY_FORM_SECTIONS } from './popAuthorityFormSchema.js'

/**
 * Step 2 "Tell us about your site": Site info + General website info sections of the POP Authority
 * form, stored as a draft (`saveDraft` + `siteInfoCompleted`) so the user can come back to it.
 * Read-only once the form has been submitted from the publishing step.
 */
export default {
  name: 'PopAuthoritySiteInfoStep',
  components: { FormStep },
  props: {
    site: { type: Object, default: null },
    activeAudit: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  data () {
    return {
      schema: makePopAuthorityFormSchema(),
      sections: POP_AUTHORITY_FORM_SECTIONS.SITE_INFO,
      readinessTick: 0,
      saving: false,
      error: '',
    }
  },
  computed: {
    canContinue () {
      void this.readinessTick
      const form = this.$refs.formStep
      return Boolean(form && form.isFormValid)
    },
  },
  methods: {
    async save () {
      if (this.saving || !this.$refs.formStep) return
      this.saving = true
      this.error = ''
      try {
        const ok = await this.$refs.formStep.submitForm()
        if (ok) {
          this.$emit('done')
        } else {
          this.error = 'Please fill the required fields marked with *.'
        }
      } catch (e) {
        this.error = 'Could not save your answers. Please try again.'
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './setup.scss';

.pa-site-info {
  max-width: 860px;
  color: $pa-teal;
}

.pa-spin--light {
  border-color: rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
}
</style>
